import { render, staticRenderFns } from "./SysVisit.vue?vue&type=template&id=0906f31a"
import script from "./SysVisit.vue?vue&type=script&lang=js"
export * from "./SysVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports